module.exports = __webpack_public_path__ + "img/icon-sti-sc.40792fb2.svg";